import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Grid,
} from "@material-ui/core";
import * as React from "react";
import CompanyCardComponent from "../components/CompanyCardComponent";
import AddCompanyDialog, { MODE_TYPE } from "../dialogs/AddCompanyDialog";
import { CompaniesService } from "../services/CompaniesService";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import { TOOL_BAR_BUTTON_TYPES } from "./DashboardScreen";
import BaseComponent from "../components/BaseComponent";
import history from "../utils/history";
import { AuthConsumer } from "../routes/AuthContext";
import FileManagmentDialog from "../dialogs/FileManagmentDialog";
import AddCompanyImageAlert from "../dialogs/AddCompanyImageAlert";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  companies: any;
  onItemClicked: any;
  updateToolBarButton: any;
  profileData: any;
}
class CompaniesScreen extends React.Component<Props> {
  state = {
    companies: [],
    mobileOpen: false,
    openCompany: false,
    selectedCompany: { _id: "" },
    pageTitle: "",
    openHelpDialog: false,
    toolBarData: { title: "", type: "", callBack: null },
    openAddCompanyDialog: false,
    openAddCompanyImage: false,
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: true });
  };

  componentDidMount = () => {
    this.getCompanies();

    // const { updateToolBarButton } = this.props;
    // if (updateToolBarButton) {
    //   updateToolBarButton("COMPANY", "Companies", this.onAddCompaniesCalled);
    // }
  };
  handleAddCompany = () => {
    this.setState({ openAddCompanyDialog: true });
  };

  onUpdatePage = () => {
    this.getCompanies();
  };

  getCompanies = () => {
    let displayCompanyData = { show: false, data: null };
    let companiesService: CompaniesService = new CompaniesService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.getCompanies().then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.companies) {
        this.setState(
          {
            companies: resp.companies,
            showCompanies: true,
            showToolBarButton: true,
            displayCompanyData: displayCompanyData,
            toolBarData: {
              title: "Companies",
              type: TOOL_BAR_BUTTON_TYPES.COMPANY,
              callBack: this.handleAddCompany,
            },
            pageTitle: "COMPANIES",
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
          }
        );
      } else {
        this.setState({
          showCompanies: false,
          showToolBarButton: false,
        });
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        }
      }
    });
  };
  onAddCompaniesCalled = () => {
    this.setState({ openAddCompanyDialog: true });
  };
  handleClose = () => {
    this.setState({
      openAddCompanyImage: false,
      openAddCompanyDialog: false,
      openHelpDialog: false,
    });
  };
  handleOnSubmit = (values: any) => {
    let companiesService: CompaniesService = new CompaniesService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.addCompany(values).then((resp) => {
      this.setState({ openAddCompanyDialog: false });
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState({ openAddCompanyImage: true });
        this.onUpdatePage();
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        this.setState({ isLoading: false });
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: "Oops something happened",
        });
      }
    });
  };
  renderAddCompanyDialog = () => {
    return (
      <AddCompanyDialog
        title={"Add Company"}
        mode={MODE_TYPE.ADD}
        open={this.state.openAddCompanyDialog}
        handleClose={this.handleClose}
        handleOnSubmit={this.handleOnSubmit}
      />
    );
  };

  renderUploadCompanyImage = () => {
    return (
      <AddCompanyImageAlert
        dialogTitle={"Upload Image"}
        open={this.state.openAddCompanyImage}
        handleClose={this.handleClose}
        handleOk={() => {
          this.setState({
            openAddCompanyImage: false,
          });
        }}
      />
    );
  };

  onClick = (event: any, company: any) => {
    const { profileData } = this.props;
    let paramObj = { profileData: profileData, companyId: company._id };
    history.push({
      pathname: `/segpi/companies/company`,
      state: paramObj,
    });
  };

  renderFileManagementDialog = () => {
    return (
      <FileManagmentDialog
        open={this.state.openHelpDialog}
        dialogTitle={"Manage Templates"}
        onClose={this.handleClose}
      />
    );
  };

  onHelperClicked = () => {
    this.setState({
      openHelpDialog: true,
    });
  };

  render() {
    const { classes, profileData } = this.props;
    return (
      <React.Fragment>
        {this.renderAddCompanyDialog()}
        {this.renderFileManagementDialog()}
        {this.renderUploadCompanyImage()}
        {this.renderAddCompanyDialog()}
        <AuthConsumer>
          {() => (
            <BaseComponent
              onHelperClicked={this.onHelperClicked}
              profileData={profileData}
              companies={this.state.companies}
              pageTitle={this.state.pageTitle}
              toolBarData={this.state.toolBarData}
            >
              <Grid
                container
                className={classes.root}
                spacing={2}
                style={{ margin: 10 }}
              >
                <Grid item xs={12}>
                  <Grid container spacing={10}>
                    {this.state.companies.map((company: any, index: Number) => (
                      <Grid key={index.toString()} item>
                        <CompanyCardComponent
                          companyData={company}
                          onClick={(event: any) => this.onClick(event, company)}
                          onUpdatePage={this.onUpdatePage}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </BaseComponent>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(CompaniesScreen);
